import { getParkingType } from 'store/selectors/selectors';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import UrlUtils from '@spothero/utils/url';
function isParkingTypeIncludedInRevamp(parkingType) {
    const isMatchingParkingType = parkingType === 'transient' ||
        parkingType === 'monthly' ||
        parkingType === 'event' ||
        parkingType === 'power_booking';
    return isMatchingParkingType;
}
export const useShowNewSearchHeader = () => {
    const { pathname, search } = useLocation();
    const parkingType = useSelector(getParkingType);
    const isMatchingParkingType = isParkingTypeIncludedInRevamp(parkingType);
    const queryParams = UrlUtils.parseParams(search);
    return (isMatchingParkingType &&
        pathname === '/search' &&
        queryParams.kind !== 'airport'); // Restrict to only search and not airport
};
